// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper_1-RWm","wrapperMode":"style_wrapperMode_vO7bA","wrapperOpacity":"style_wrapperOpacity_gLCzw"};